import { render, staticRenderFns } from "./tzlxgz.vue?vue&type=template&id=2cd6b70d&scoped=true&"
import script from "./tzlxgz.vue?vue&type=script&lang=js&"
export * from "./tzlxgz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd6b70d",
  null
  
)

export default component.exports